enum UrlSearchParams {
  PERIOD_TYPE = "periodType",
  DATE = "date",
  SITE_ID = "siteId",
}

export default UrlSearchParams;
